import { Engine, Scene } from "@babylonjs/core";
import { useCallback, useEffect, useState } from "react";

interface BabylonCanvasProps {
    initScene(scene: Scene): void;
}

export default function BabylonCanvas(props: BabylonCanvasProps) {
    const { initScene } = props;

    const [engine, setEngine] = useState<Engine | null>(null);
    const canvasRef = useCallback((canvas: HTMLCanvasElement) => {
        if (canvas !== null) {
            setEngine(new Engine(canvas));
        }
    }, []);

    useEffect(() => {
        if (!engine) return;

        let resize = () => {
            let canvas = engine.getRenderingCanvas();
            if (canvas) {
                // Remove explicit size so CSS can choose
                canvas.width = 0;
                canvas.height = 0;
            }

            engine.resize();
        }
        window.addEventListener('resize', resize);

        return () => {
            window.removeEventListener('resize', resize);
            engine.dispose();
        }
    }, [engine])

    useEffect(() => {
        if (!engine) return;

        let scene = new Scene(engine);
        initScene(scene);
        engine.runRenderLoop(function () {
            scene.render();
        });

        return () => {
            scene.dispose();
        };
    }, [engine, initScene]);

    return <canvas ref={canvasRef} />
}
